import commonFun from "@/assets/js/yioks";
import { getUserInfo } from '@/api/document/document';
const { idCard_number } = commonFun;
export default {
    data(){
        return{
            formRules:{
                name:[
                    {required: true, message: '姓名不能为空', trigger: 'blur'},
                ],
                mobile_phone:[
                    {required: true,
                        validator: (rule, value, callback) => {
                        if (value){
                            this.$yioks.phone(value) ? callback() : callback(new Error('请输入正确的联系电话'));
                        } else{
                            callback(new Error('手机号不能为空'));
                        }
                        },
                        trigger: "blur",}
                ],
                id_number:[
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value){
                                getUserInfo(value).then(res=>{
                                  if(res.data.status !== 0) {
                                    this.credential.name = '';
                                    this.credential.mobile_phone = '';
                                  }else{
                                    const {result} = res.data;
                                    if(result.userInfo.name) {
                                      this.credential.name = result.userInfo.name;
                                      this.credential.mobile_phone = result.userInfo.mobile_phone;
                                      this.$refs["form"].clearValidate('name');
                                      this.$refs["form"].clearValidate('mobile_phone');
                                    }
                                    callback()
                                  }
                                })
//                              callback()
                            }else{
                                callback(new Error('请输入证件号'))
                            }

                        },
                        trigger: "blur"
                    }
                ],
              credential_title:[
                {required: true, message: '请填写文件标题', trigger: 'blur'},
              ],
                remark:[
                    {required: true, message: '请填写备注说明', trigger: 'blur'},
                ],
            }
        }
    }
}
